import { actionTypes } from "../actions/MlAdminUserActions";
import { SortTypes } from "../../util/table-view/TableTypes";
import { defaultResultsPerPage, pagingTotalRelation } from "../Types";

const initialState = {
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  loading: false,
  loadingMore: false,
  posting: { busy: false, message: "", errors: null },
  editing: null,
  changedFields: [],
  noMore: true,
  query: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
  },
  errors: null,
  history:{},
  loadingGroups: false,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        loadingMore: false,
        errors: null,
        selectedItems: [],
        items: [],
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: null,
        items: action.payload,
        totalItems: action.total,
        totalRelation: action.totalRelation,
        selectedItem: action.payload[0] || {},
        selectedItems: [],
        noMore: false,
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
        noMore: true,
      };

    case actionTypes.CLEAR_PROFILE_IMAGE:
      return {
        ...state,
        editing: {
          ...state.editing, 
          imageUrl:null
        }, 
        posting: {
          busy: false,
          message: "",
          errors: null,
        }
      };

    case actionTypes.UPDATE_PROFILE_IMAGE:
      return {
        ...state,
        editing: {
          ...state.editing, 
          imageUrl:action.payload
        }
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };

    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
        errors: null,
      };

    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: action.payload? action.payload: "",
          errors: null,
        },
        changedFields:[], 
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.LOAD_HISTORY:
      state.history[action.payload.userId] = action.payload.history
      return {
        ...state
      };

    case actionTypes.REMOVE_HISTORY:
      action.payload.forEach(function(id) {
        delete state.history[id];
      });
       
      return {
        ...state
      };

      case actionTypes.LOADING_GROUPS:
        return {
          ...state,
          loadingGroups: true,
        };

      case actionTypes.LOAD_GROUPS:
        return {
          ...state,
          editing: {
            ...state.editing, 
            usersGroupsList: action.payload
          }, 
          loadingGroups: false,
        };

        case actionTypes.ERROR_LOADING_GROUPS:
          return {
            ...state,
            loadingGroups: false,
          };

    default:
      return state;
  }
}
